export class RequestToAgreeTariffDayType {
    requestToAgreeTariffDayTypeId: number;
    requestToAgreeTariffId: number;
    dayType: number;
}